import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Panda(props: PresetArtProps) {
  return (
    <PresetFrame background="#16a34a" {...props}>
      <circle cx="20" cy="21" r="7" fill="#1f2937" />
      <circle cx="44" cy="21" r="7" fill="#1f2937" />
      <circle cx="32" cy="36" r="16" fill="#ffffff" />
      <ellipse cx="25" cy="33" rx="4.5" ry="5.5" fill="#1f2937" />
      <ellipse cx="39" cy="33" rx="4.5" ry="5.5" fill="#1f2937" />
      <ellipse cx="32" cy="43" rx="3.5" ry="2.5" fill="#1f2937" />
    </PresetFrame>
  );
}
